import type { RouteObject } from 'react-router';

import { ENV } from '@shared/config';

import { sharedLoader } from './shared-loader';
import { uiKitRoutes } from './ui-kit';
import { systemRoutes } from './system';
import { settingsRoutes } from './settings';

export const sharedRoutes: RouteObject = {
  loader: sharedLoader,
  children: [
    ...(ENV.IS_DEVELOPMENT_MODE ? [uiKitRoutes] : []),
    settingsRoutes,
    systemRoutes,
  ],
};
